import { Users } from "lucide-react";
import { Layout } from "@/components/Layout";
import AdminUsersSection from "@/components/master-users/AdminUsersSection";
import MemberUsersSection from "@/components/master-users/MemberUsersSection";

export default function MasterUsers() {
  return (
    <Layout>
      <div className="p-4 sm:p-8 lg:p-12 max-w-[1400px] space-y-6">
        <header>
          <div className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-primary font-medium mb-2 mono"><Users size={14} /> Pengelolaan Akun</div>
          <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight">Master Pengguna</h1>
          <p className="text-muted-foreground mt-2 text-sm sm:text-base">Kelola admin, member, dan akun departemen.</p>
        </header>
        <AdminUsersSection />
        <MemberUsersSection />
      </div>
    </Layout>
  );
}
